import { createTheme } from "@mui/material/styles";
import { ptBR as materialPtBR } from "@mui/material/locale";
import { ptBR as dataGridPtBR } from "@mui/x-data-grid/locales";

function createCustomTheme(mode: "light" | "dark") {
  return createTheme(
    {
      palette: {
        mode,
        primary: {
          // Azul padrão da aplicação (consistente com componentes)
          main: "#24324D",
          contrastText: "#ffffff",
          // Removemos 'dark' e 'light' customizados para deixar o MUI calcular
          // tons corretos automaticamente (evita hover branco/invisível).
        },
        secondary: {
          main: "#c51162",
        },
      },
    },
    materialPtBR,
    dataGridPtBR
  );
}

export default createCustomTheme;